import React from 'react';

import { BodyRegularBR2, HeadlineH8 } from 'common/components/Typography';
import { useLocalization } from 'common/providers/LocaleProvider';
import type { BannerVoucherV2Props } from '../BannerVoucherV2';
import CountDown from './CountDown';

interface CampaignSectionProps extends Pick<
  BannerVoucherV2Props,
  'shortName' | 'countdownEndDate'
> {
  isHeadline?: boolean;
}

const CampaignSection = ({
  shortName,
  countdownEndDate,
  isHeadline = false,
}: CampaignSectionProps) => {
  const { t } = useLocalization();

  if (!shortName && !countdownEndDate) return null;

  const TypoComponent = isHeadline ? HeadlineH8 : BodyRegularBR2;

  return (
    <TypoComponent data-testid="campaign-section" color="inherit">
      {shortName && countdownEndDate ? (
        <CountDown
          label={`${shortName} ${t('h24_countdown_lower_label')}`}
          countdownEndDate={countdownEndDate}
        />
      ) : !shortName && countdownEndDate ? (
        <CountDown label={t('h24_countdown_banner_label')} countdownEndDate={countdownEndDate} />
      ) : (
        shortName
      )}
    </TypoComponent>
  );
};

export default CampaignSection;
